import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import { IExtensionViewEnteredMessageParameters } from '#/CoreFrameInterfaces';

export default class ExtensionViewEnteredMessage extends Message {

    public title: KnockoutObservable<string>;
    public key: string;
    public PDO_ID: string;

    public constructor(params: IExtensionViewEnteredMessageParameters) {
        super(params);

        this.title = this.observableOrDefault(params.title, null);

        this.key = this.paramOrDefault(params.key, null); // TODO: Wird dieser Parameter wirklich benötigt?
        this.PDO_ID = this.paramOrDefault(params.PDO_ID, null); // TODO: Wird dieser Parameter wirklich benötigt?
    }
}

ComponentManager.setMessage('ExtensionViewEnteredMessage', ExtensionViewEnteredMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');